import * as React from 'react';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { Formik, FormikProps } from 'formik';
import { Member } from 'common/api/models/Member';
import { MemberApi } from 'common/api/resources/MemberApi';
import { toApiError } from 'common/utils/api';
import { CONTACT_TYPES } from '../../common/constants';
import { SimpleDialog } from './OrgsEmployees';

interface AssignContactDialogProps extends SimpleDialog {
  org: Member;
  user?: Member;
}
export class AssignContactDialog extends React.Component<AssignContactDialogProps> {
  initialValues() {
    const result: any = {};
    for (let c of CONTACT_TYPES) {
      result[c.value] =
        this.props.user &&
        this.props.org &&
        this.props.org.contacts &&
        this.props.org.contacts[c.value] === this.props.user.id;
    }
    return result;
  }

  handleSubmit = (values: any) => {
    const userId = this.props.user!.id;
    const contacts: any = this.props.org.contacts ? { ...this.props.org.contacts } : {};
    for (let c of CONTACT_TYPES) {
      const checked = values[c.value];
      if (checked && contacts[c.value] !== userId) {
        contacts[c.value] = userId;
      }
      if (!checked && contacts[c.value] === userId) {
        delete contacts[c.value];
      }
    }
    MemberApi.updateMember(this.props.org.id!, { contacts }).then(
      res => {
        this.props.onConfirm();
      },
      err => {
        this.setState({ error: toApiError(err) });
      }
    );
  };

  render() {
    const { user } = this.props;
    return (
      <Modal size="sm" isOpen={!!this.props.user} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<any>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>Assign Contact: {user ? user.name : ''}</ModalHeader>
              <ModalBody>
                {CONTACT_TYPES.map(c => (
                  <div key={c.value}>
                    <label>
                      <input
                        type="checkbox"
                        name={c.value}
                        checked={form.values[c.value]}
                        onChange={form.handleChange}
                      />{' '}
                      {c.label}
                    </label>
                  </div>
                ))}
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    Save
                  </Button>
                </div>
              </ModalFooter>
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Orgs/AssignContactDialog.tsx